import request from '../../utils/request';

export const inputChoiceService = {
    //下拉列表列表数据查询
    getInputChoiceValues: (data) => {
        return request({
            url: '/inputChoice/queryAutoloadInputChoice',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    //下拉列表列表数据查询(同步)
    getSyncInputChoiceValues: (data) => {
        return request({
            url: '/inputChoice/queryAutoloadInputChoice',
            method: 'POST',
            async: false,//同步方法
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    //下拉列表列表数据查询
    listInputChoice: (data) => {
        return request({
            url: '/inputChoice',
            method: 'get',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    getCurrencyList: () => {
        return request({
            url: '/currency',
            method: 'get',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: {}
        })
    }
}
